/*
 * Copyright (c) 2019. IOWEB TECHNOLOGIES
 */

import $ from 'jquery';

$(document).ready(function () {
   let $identity = $('#identity');
   if($identity.length>0){
       $('.form-group.id-gender input').prop('disabled', true);
       $('.form-group.firstname input').prop('readonly', true);
       $('.form-group.lastname input').prop('readonly', true);
       $('.form-group.email input').prop('readonly', true);
   }
});